import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from "react";
import { connect } from "react-redux";
import {
    Button,
    Form,
    FormFeedback,
    FormGroup,
    FormText,
    Input,
    Label
} from "reactstrap";
import Message from "../../CommonData/Data/Message.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";
import AsyncSelect from "react-select/async";
import {
    clearSubmitReturnRequestsActionError,
    getAssignedDevicesForAsyncSelect,
    getReasonForAsyncSelect,
    setReturnRequestsForm,
    submitReturnRequestsAction
} from "../../store/returnRequests/actions.js";
import { CUSTOMER } from "../../store/users/role.constants.js";


const AddReturnRequest = (props) => {
    const { returnRequestsForm, errorMessage, handleClose, isPending, currentProfile } = props;
    const { notes, errors } = returnRequestsForm || {};
    const { roles } = currentProfile || {};
    const [selectedDevice, setSelectedDevice] = useState();
    const [selectedReason, setSelectedReason] = useState();
    const textareaRef = useRef(null);

    const isEndUser = roles && roles.length > 0 && roles[0].roleKey === CUSTOMER;

    useEffect(() => {
        props.setReturnRequestsForm({
            errors: {}
        })
        props.clearSubmitReturnRequestsActionError();

        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const validateOnChange = (event) => {
        const { name, value } = event.target;
        props.setReturnRequestsForm(
            {
                ...returnRequestsForm,
                [name]: value,
                errors: {
                    ...returnRequestsForm.errors,
                    [name]: null,
                }
            })
        autoResize();
    };

    const handleLoadUnAssignedDevices = (inputValue, callback) => {
        props.getAssignedDevicesForAsyncSelect(inputValue, callback, isEndUser);
    };

    const handleAddMasterDeviceUnassignedChange = (value) => {
        const sNo = value && value.map((device) => device.value);
        setSelectedDevice(value);
        props.setReturnRequestsForm({
            ...returnRequestsForm,
            deviceKeys: sNo,
            errors: {
                ...returnRequestsForm.errors,
                deviceKeys: null,
            }
        });
    }

    const handleLoadReason = (inputValue, callback) => {
        props.getReasonForAsyncSelect(inputValue, callback);
    };

    const handleAddReasonChange = (option) => {
        const { label } = option || {};
        setSelectedReason(option);
        props.setReturnRequestsForm({
            ...returnRequestsForm,
            reason: label,
            errors: {
                ...returnRequestsForm.errors,
                reason: null,
            }
        });
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            props.setReturnRequestsForm(
                {
                    ...returnRequestsForm,
                    notes: (returnRequestsForm && returnRequestsForm.notes) ? returnRequestsForm.notes + "\n" : "\n",
                    errors: {
                        ...returnRequestsForm.errors,
                        notes: null,
                    }
                })
            autoResize();
        }
    };

    const autoResize = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    const handleSubmit = () => {
        const { action, requestId } = props;
        const { deviceKeys, reason } = returnRequestsForm || {};
        let currentErrors = {};
        if (!deviceKeys || (deviceKeys && deviceKeys.length === 0)) {
            currentErrors.deviceKeys = "Device is required";
        }
        if (!reason) {
            currentErrors.reason = "Reason is required"
        }
        props.setReturnRequestsForm(
            {
                ...returnRequestsForm,
                errors: currentErrors
            })
        if (Object.keys(currentErrors).length === 0) {
            props.submitReturnRequestsAction(action, requestId);
        }
    };
    console.log("isEndUser: ", isEndUser);
    return isPending ? (<VWLoading />) : (
        <Fragment>
            {errorMessage && (
                <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                />
            )}
            <Form className="mb-3" name="formApprovalAction">
                <FormGroup>
                    <Label>
                        Devices<span className="text-danger">*</span>
                    </Label>
                    <AsyncSelect
                        autoFocus
                        openMenuOnFocus={true}
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: (errors && errors.deviceKeys) ? 'red' : "silver"
                            })
                        }}
                        isMulti
                        id="selected_device"
                        name="selected_device"
                        placeHolder="Select device"
                        defaultOptions
                        loadOptions={handleLoadUnAssignedDevices}
                        onChange={handleAddMasterDeviceUnassignedChange}
                        value={selectedDevice}
                    />
                    {(errors && errors.deviceKeys) &&
                        <FormText sx={{ marginLeft: "10px" }}>
                            <div className="text-danger">
                                {errors && errors.deviceKeys}
                            </div>
                        </FormText>
                    }
                </FormGroup>
                <FormGroup>
                    <Label>
                        Reason<span className="text-danger">*</span>
                    </Label>
                    <AsyncSelect
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: (errors && errors.reason) ? 'red' : "silver"
                            })
                        }}
                        id="selected_reason"
                        name="selected_reason"
                        placeHolder="Select Reason"
                        defaultOptions
                        loadOptions={handleLoadReason}
                        onChange={handleAddReasonChange}
                        value={selectedReason}
                    />
                    {(errors && errors.reason) &&
                        <FormText sx={{ marginLeft: "10px" }}>
                            <div className="text-danger">
                                {errors && errors.reason}
                            </div>
                        </FormText>
                    }
                </FormGroup>
                <FormGroup>
                    <Label>Notes</Label>
                    <Input
                        innerRef={textareaRef}
                        type="textarea"
                        name="notes"
                        placeholder="Enter notes"
                        onChange={validateOnChange}
                        value={notes || ""}
                        rows={1}
                        onKeyDown={handleKeyDown}
                        style={{
                            minHeight: "30px",
                            resize: "none",
                            overflow: "hidden",
                        }}
                    />
                </FormGroup>
            </Form>
            <FormGroup>
                <Button
                    className='me-4'
                    color="success"
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
                <Button
                    color="danger"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
            </FormGroup>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    returnRequestsForm: state.returnRequests.returnRequestsForm,
    errorMessage: state.returnRequests.errorMessage,
    isPending: state.returnRequests.isPending,
    currentProfile: state.login.currentProfile,

});

const mapDispatchToProps = (dispatch) => ({
    setReturnRequestsForm: (returnRequestsForm) => dispatch(setReturnRequestsForm(returnRequestsForm)),
    submitReturnRequestsAction: (action, requestId) => dispatch(submitReturnRequestsAction(action, requestId)),
    clearSubmitReturnRequestsActionError: () => dispatch(clearSubmitReturnRequestsActionError()),
    getAssignedDevicesForAsyncSelect: (inputValue, callback, isEndUser) => dispatch(getAssignedDevicesForAsyncSelect(inputValue, callback, isEndUser)),
    getReasonForAsyncSelect: (inputValue, callback) => dispatch(getReasonForAsyncSelect(inputValue, callback))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReturnRequest);
